var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconField({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.24999 6.00001L5.41666 7.16668L7.74999 4.83334M10.6667 6.00001C10.6667 8.60232 7.48166 10.488 6.37414 11.0651C6.25439 11.1275 6.19448 11.1587 6.11141 11.1749C6.04666 11.1875 5.95333 11.1875 5.88858 11.1749C5.80551 11.1587 5.7456 11.1275 5.62584 11.0651C4.5183 10.488 1.33333 8.60232 1.33333 6.00001V3.7936C1.33333 3.32722 1.33333 3.09403 1.40961 2.89358C1.47699 2.7165 1.58648 2.5585 1.72863 2.43323C1.88954 2.29143 2.10788 2.20955 2.54456 2.04579L5.67228 0.8729C5.79355 0.827423 5.85416 0.804685 5.91658 0.795667C5.97188 0.787675 6.02811 0.787675 6.08341 0.795667C6.14583 0.804685 6.20644 0.827423 6.32771 0.8729L9.45543 2.04579C9.89211 2.20955 10.1105 2.29143 10.2713 2.43323C10.4135 2.5585 10.523 2.7165 10.5904 2.89358C10.6667 3.09403 10.6667 3.32722 10.6667 3.7936V6.00001Z",
    stroke: "#10A37F",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconField);
export default __webpack_public_path__ + "static/media/icon-field.709edb8f881f2b8bc6bfd4f2d7103d8f.svg";
export { ForwardRef as ReactComponent };